import { useTexts } from '@/feature/lang';
import { track } from '@/feature/tracking';
import { Icon } from '@/icon/Icon';
import MiniButton from '../Button/MiniButton';
import Translate from '../Translate';

export const Previous = ({ stepper, onClick }: any) => {
  const { component } = useTexts();

  const previous = () => {
    const { from, to } = stepper.previous();
    onClick({ from, to });
    track('daterange_previous');
  };

  return (
    <MiniButton
      startIcon={<Icon name="chevron_left" size="xsmall" />}
      onClick={previous}
    >
      <Translate text={component.button.common.previous} />
    </MiniButton>
  );
};

export const Next = ({ stepper, onClick }: any) => {
  const { component } = useTexts();

  const next = () => {
    const { from, to } = stepper.next();
    onClick({ from, to });
    track('daterange_next');
  };

  return (
    <MiniButton
      endIcon={<Icon name="chevron_right" size="xsmall" />}
      onClick={next}
    >
      <Translate text={component.button.common.next} />
    </MiniButton>
  );
};
